import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withNamespaces } from 'react-i18next';
import { renderError } from '../../tools/validation';

const propTypes = {
  label: PropTypes.string,
  addClassName: PropTypes.string,
  names: PropTypes.array.isRequired,
  lang: PropTypes.string,
};

const defaultProps = {
  label: null,
  addClassName: '',
  lang: '',
};

const LangField = ({ names, lang, ...props }) => (
  <div className={`c-bb-form__input-wrapper ${props.addClassName}`} >
    {names.map(name => (
      <div
        key={`LangField-${name}`}
        className={classNames([
          'c-bb-form__input',
          { 'c-bb-form__input--has-error': props[name].meta.touched && props[name].meta.error },
        ])}
        style={{ display: (name.endsWith(lang.toLowerCase())) ? 'flex' : 'none' }}
      >
        <label htmlFor="title">{props.label}</label>
        <input
          onChange={props[name].input.onChange}
          value={props[name].input.value}
          name={props[name].input.name}
          type="text"
        />
        {props[name].meta.touched && props[name].meta.error &&
        <span className="c-bb-form__input-error">{renderError(props[name].meta.error)}</span>}
      </div>
    ))}
  </div>
);

LangField.propTypes = propTypes;
LangField.defaultProps = defaultProps;

export default withNamespaces()(LangField);



// WEBPACK FOOTER //
// ./src/components/FormElements/LangField.js